module.exports = __webpack_public_path__ + "static/media/adventure.82bf5979.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adventure.jpg
// module id = 22
// module chunks = 0